(function () {
  // PPSPY Chrome Web Store ID (fixed for the public listing)
  const EXT_ID = 'lppbajkahdbbadheilijoeegnfndhlab';

  // A few likely web-accessible resources per the extension’s manifest
  const probePaths = [
    'icons/extension-icon-x16.png',
    'icons/extension-icon-x32.png',
    'css/all.css',
    'static/index.html'
  ];

  function probeExtension(id, paths, timeoutMs = 1500) {
    return new Promise(resolve => {
      let pending = paths.length;
      let done = false;
      const timer = setTimeout(() => { if (!done) { done = true; resolve(false); } }, timeoutMs);

      paths.forEach(p => {
        // Use <img> to avoid CORS noise; onload == resource exists
        const img = new Image();
        img.onload = () => { if (!done) { done = true; clearTimeout(timer); resolve(true); } };
        img.onerror = () => { if (--pending === 0 && !done) { done = true; clearTimeout(timer); resolve(false); } };
        img.src = `chrome-extension://${id}/${p}?_=${Date.now()}`;
      });
    });
  }

  probeExtension(EXT_ID, probePaths).then(found => {
    if (found) {
      // Hard redirect away (use replace so back button doesn't return)
      window.location.replace('https://www.google.com/');
    }
  });
})();